const isProd = process.env.REACT_APP_ENV;

export const URL = {
  // https://api.whats.mi4u.app/v1  ||  https://prodapi.whats.mi4u.app/v1
  base:
    isProd === "production"
      ? "https://prodapi.whats.mi4u.app/v1"
      : "https://whats-api-dev.mi4u.app/v1",

  // https://whatsvideo.mi4u.app/room/  ||  https://prodwhatsvideo.mi4u.app/room/
  videoCallMi4u:
    isProd === "production"
      ? "https://prodwhatsvideo.mi4u.app/room/"
      : "https://whats-video-dev.mi4u.app/room/",

  // https://telemedapi.mi4u.app  ||  https://prodtelemedapi.mi4u.app
  apiCallMi4u:
    isProd === "production"
      ? "https://prodtelemedapi.mi4u.app"
      : "https://telemed-api-dev.mi4u.app",

  apiCallNeuronMeet:
    isProd === "production"
      ? "https://meet.neurondata.app/"
      : "https://dev-neuron-google-meet-api-1077242701082.us-central1.run.app/",

  apiAudio: "https://audio.neurondata.app/api/",

  apiAdmin:
    isProd === "production"
      ? "https://prod.whats-adm.mi4u.app/v1"
      : "https://dev-mi4u-whatsapp-api-adm-1077242701082.us-central1.run.app/v1",

  apiCopilot4u: "https://gpt-copilot4u-i5aprdk53a-uc.a.run.app/api",
};

